// choices/lightChoices.js
const lightChoicesSrb = [
  {
    label: "Природна светлост",

    value: "natural",
  },
  {
    label: "Вештачка светлост",
    value: "artificial",
  },

  {
    label: "Мешовито осветљење",
    value: "mixed",
  },
];

export default lightChoicesSrb;
